// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// настройка конкретной комиссии (по типу)
export class RevenueCommissionItem {
    constructor() {
        this.Type = null;
        this.PaymentType = null;
        this.CounterAccountID = null;
        this.IsSetIB = null;
        this.ApplyOperationType = null;
        this.CommissionValueItems = [];
    }
    GetCommission(param) {
        let value = 0;
        if (this.Type !== param.CommissionType) {
            return value;
        }
        this.CommissionValueItems.forEach(function (valueItem) {
            value += valueItem.GetCommission(param);
        });
        return value;
    }
    NeedDifferent_BuySell_Short() {
        const items = this.CommissionValueItems;
        if (items.length > 2) {
            for (let i = 1; i < items.length; i++) {
                const valItem = items[i];
                if (valItem.OperationType !== items[0].OperationType) {
                    return true;
                }
            }
        }
        if (items.length === 2 &&
            items[0].OperationType !== items[1].OperationType &&
            items[0].Value !== items[1].Value) {
            return true;
        }
        return false;
    }
    AreEqualBuyOpenCloseValues() {
        // if (CommissionValueItems != null && CommissionValueItems.Count == 2 &&
        //     (Type == CommissionTypes.PerLot || Type == CommissionTypes.OrderPerLot || Type == CommissionTypes.PerVolume || Type == CommissionTypes.PerOrderVolume) &&
        //     CommissionValueItems[0].OperationType == CommissionOpearationType.OPEN && CommissionValueItems[1].OperationType == CommissionOpearationType.CLOSE &&
        //     (CommissionValueItems[0].Value == CommissionValueItems[1].Value))
        //     return true;
        return false;
    }
    ContainsShort() {
        const items = this.CommissionValueItems;
        for (let i = 0; i < items.length; i++) {
            if (items[i].IsShort) {
                return true;
            }
        }
        return false;
    }
    ContainsOpenClose() {
        const items = this.CommissionValueItems;
        if (items.length > 1) {
            for (let i = 0; i < items.length; i++) {
                if (items[i].IsOpenOrClose) {
                    return true;
                }
            }
        }
        return false;
    }
    ContainsBuySellShort() {
        const items = this.CommissionValueItems;
        for (let i = 0; i < items.length; i++) {
            if (items[i].IsBuySellShort) {
                return true;
            }
        }
        return false;
    }
    IsSingleField() {
        if (this.NeedDifferent_BuySell_Short() || this.AreEqualBuyOpenCloseValues()) {
            return false;
        }
        return true;
    }
    IsShowOpenClose() {
        let isShowOpenClose = false;
        if (!this.NeedDifferent_BuySell_Short() && this.ContainsOpenClose()) {
            isShowOpenClose = true;
        }
        if (this.AreEqualBuyOpenCloseValues()) {
            isShowOpenClose = true;
        }
        return isShowOpenClose;
    }
    GetShowFormat() {
        let isSingleField = true;
        let isShowOpenClose = false;
        if (this.NeedDifferent_BuySell_Short()) {
            // buy/sell & short
            isSingleField = false;
        }
        if (!isSingleField && this.ContainsOpenClose()) {
            isShowOpenClose = true;
        }
        if (this.AreEqualBuyOpenCloseValues()) {
            isSingleField = false;
            isShowOpenClose = true;
        }
        return { isSingleField, isShowOpenClose };
    }
    GetLotsListForType(outLotsArray, commissionType, operationType) {
        if (this.Type !== commissionType) {
            return;
        }
        const items = this.CommissionValueItems;
        for (const item of items) {
            item.GetLotsListForType(outLotsArray, operationType);
        }
    }
}
